import React, {Component, Fragment } from 'react';
import via1 from '../../../images/driverpolicy-images/via-acc.png';
import via2 from '../../../images/driverpolicy-images/via-enter.png';
import wifi from '../../../images/driverpolicy-images/wifi.png';

class IncorrectUse extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render(){
  	const { city } = this.props;
    return(

      <Fragment>
      <span id='incorrectuse' className='anchor2'></span>
        <div className='incorrect__content--container'>
            <span className='damages__title--container'>
              <img src={wifi}/>
              { city === 'new_york' ? (<h3><strong>Use correct plate on Via</strong></h3>):
              (<h3><strong>Incorrect use of plate on Uber</strong></h3>)}
            </span> 
            <br/>
            { city === 'new_york' ? (<p>
              Make sure that you select the correct vehicle plate in the Via Driver App.
            </p>):
              (<p>
              When you are assigned a car, make sure that you select the correct vehicle plate in the Uber Driver App.
            </p>)}
            <br/>

          { city === 'new_york' ? (
          	<div className="via-images">
                  <img 
                    src={via1}
                  />
                  <img
                    src={via2}
                  />
            </div>):(
            <div className="block-video">
            	<iframe src={`https://www.youtube.com/embed/GbD5NzM0FRE`} frameBorder="0" allowFullScreen title="Instructions" />
          	</div>)}
            { city === 'new_york' ? null : (<p>
              Please note that using the wrong plate during your booking or staying online longer than your booking will block another driver from going online, and will incur a fee of $15.
            </p>)}
            <br/>
            <br/>
        </div>
      </Fragment>

    )
  }
 }

export default IncorrectUse;


// WEBPACK FOOTER //
// ./src/components/Static/DriverPolicy/IncorrectUse.js